import pdfMake from 'addthaifont-pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
// import imageToBase64 from 'image-to-base64/browser';

// import logoImage from '../../assets/img/companyLogo.jpeg';

pdfMake.fonts = {
  Sarabun: {
    normal: 'Sarabun-Light.ttf',
    bold: 'Sarabun-Regular.ttf',
    italics: 'Sarabun-LightItalic.ttf',
    bolditalics: 'Sarabun-Italic.ttf',
  },
};
dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

const leaveReportNew = async (data) => {
  const calculateDayLeave = () => {
    const date1 = dayjs(data?.dateEnd).startOf('day');
    const date2 = dayjs(data?.dateStart).startOf('day');
    const date = date1.toDate().getTime() - date2.toDate().getTime();

    const sumday = date / (1000 * 3600 * 24);

    return sumday + 1;
  };
  console.log('data', data);

  const documentRef = {
    pageSize: 'A4',
    pageOrientation: 'portait',
    pageMargins: [20, 20, 20, 20],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '9',
    },

    content: [
      { text: 'แบบใบลา', style: 'header', margin: [0, 0, 0, 20] },
      {
        table: {
          widths: ['*', '40%'],
          body: [
            [
              {
                text: '',
                border: [false, false, false, false],
              },
              {
                text: 'เขียนที่  ' + `${data?.address || '-'}\n`,
                style: 'body',

                border: [false, false, false, false],
              },
            ],
            [
              { text: '', border: [false, false, false, false] },
              {
                text:
                  '\nวันที่   ' +
                  `${dayjs(data.date).format('DD เดือน MMMM พ.ศ BBBB')}`,
                style: 'body',

                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
      {
        text: 'เรื่อง  ......................................',
        margin: [40, 10, 14, 0],
        style: 'body',
      },
      {
        text: 'เรียน ' + `${data?.approverName || '-'}`,
        margin: [40, 10, 14, 0],
        style: 'body',
      },
      {
        text: [
          {
            text: '.\t\t\t',
            style: 'tab',
          },
          {
            text:
              'ข้าพเจ้า  ' +
              `${data?.name || '-'}\t` +
              `${data?.surname || '-'}\t`,
            style: 'body',
          },
          'ตำแหน่ง \t' +
            `${data?.position || ''}\t` +
            'สังกัดฝ่าย \t' +
            `${data?.under || ''}`,
          'ขอ' +
            `${data?.leaveTypeID?.name || ''}\t` +
            'ช่วงเวลาการลา \t' +
            `${data?.statusAllDay === true ? 'เต็มวัน' : 'ครึ่งวัน'}\t` +
            'เนื่องจาก ' +
            `${data?.leaveCause || '-'}\t` +
            ' ตั้งแต่วันที่ ' +
            `${dayjs(data?.dateStart).format('DD MMMM BBBB') || ''} ` +
            ' ถึงวันที่ ' +
            `${dayjs(data?.dateEnd).format('DD MMMM BBBB') || ''}  ` +
            ` มีกำหนด ${calculateDayLeave()} วัน\t`,

          'โดยข้าพเจ้าได้ ' +
            `${data?.leaveType || ''} ` +
            ' ครั้งสุดท้ายเมื่อวันที่  ' +
            `${dayjs(data?.dateStart).format('DD MMMM BBBB') || ''}   ` +
            ' ถึงวันที่    ' +
            `${dayjs(data?.dateEnd).format('DD MMMM BBBB') || ''}  ` +
            ` มีกำหนด  ${calculateDayLeave()} วัน\t` +
            ' ในระหว่างลาจะติดต่อข้าพเจ้าได้ที่ \t' +
            `${data.contact || '-'}\t`,
        ],
        margin: [40, 10, 14, 0],
        style: 'body',
      },
      {
        text: 'จึงเรียนมาเพื่อโปรดพิจารณา',
        decoration: 'underline',
        margin: [220, 15, 14, 0],
        style: 'body',
      },
      {
        text:
          'ลงชื่อ................................................ ' +
          `(${data?.name || '...............................'})\t` +
          'ว/ด/ป .............................',
        margin: [100, 15, 14, 20],
        style: 'body',
      },
    ],

    footer: [],

    styles: {
      header: {
        fontSize: 16,
        bold: true,
        alignment: 'center',
      },
      header1: {
        fontSize: 14,
        bold: true,
        alignment: 'left',
      },
      header2: {
        fontSize: 13,
        bold: true,
        alignment: 'left',
      },
      body: {
        fontSize: 11,
        alignment: 'left',
      },
      body2: {
        alignment: 'center',
        fontSize: 11,
        bold: true,
      },
      body1: {
        alignment: 'left',
        fontSize: 12,
        bold: true,
      },
      bodySign: {
        alignment: 'center',
        fontSize: 12,
      },
      bodySign2: {
        alignment: 'center',
        fontSize: 11,
        bold: true,
      },
      tab: {
        color: 'white',
      },
    },
    images: {},
  };
  pdfMake.createPdf(documentRef).open();
};
export default leaveReportNew;
